import React from "react";
import { useState, useEffect, useRef } from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import ScorecardFilters from "../App/ScorecardFilters";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import TabFilter from "../App/TabFilter";
import MultiTabFilter from "../App/MultiTabFilter";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import DownloadPopup from "../App/DownloadPopup";
import { SortTheList } from "../Shared/Utility";

function MonthLeagueTable() {
  let toggledatarangeArray = [
    { Name: "Absolute", ID: 1 },
    { Name: "Comparative", ID: 2 },
  ];
  let toggledataArray = [
    { Name: "Retailer", ID: 1 },
    { Name: "Importer", ID: 2 },
  ];

  const [screenID, setScreenID] = useState(9);
  const [MonthTableFactorKeysData, setMonthTableFactorKeysData] = useState<any>(
    []
  );
  const [showLoadinganimation, setShowLoadinganimation] = useState(false);

  const [selectedId, setSelectedId] = useState({
    Dealers: 0,
    Facilities: 0,
    Years: 0,
    Months: 0,
    Brand: 0,
  });

  const [tabFilterObject, setTabFilterObject] = useState({
    toggledata: 1,
    Toggledatarange: 1,
    typeofreportdata: 1,
  });

  ///--States for columnFilter components---///
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [filterLists, setFilterLists] = useState([]);
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({ x: event.clientX, y: event.clientY });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = MonthTableFactorKeysData as any;
    l_data[1] = FilterData;
    setMonthTableFactorKeysData(l_data);
    thisGridListDataRef.current = FilterData;
    HandleSortAndLoadData();
  }

  //--States for columnFilter components---///

  function handleTabFilterCallback(TabFilterData: any) {
    let ID = TabFilterData.ID;
    let Type = TabFilterData.Type;
    if (Type === 1) {
      tabFilterObject.Toggledatarange = ID;
      setTabFilterObject((prevState: any) => ({
        ...prevState,
        Toggledatarange: ID,
      }));
    } else if (Type === 2) {
      tabFilterObject.toggledata = ID;
      setTabFilterObject((prevState: any) => ({
        ...prevState,
        toggledata: ID,
      }));
    }
  }

  function ScorecardFiltersCallBack(p_selectedId: any) {
    selectedId.Dealers = parseInt(p_selectedId.Dealers);
    if (selectedId.Dealers === 0) {
      selectedId.Facilities = 0;
    } else {
      selectedId.Facilities = parseInt(p_selectedId.Facilities);
    }
    selectedId.Years = p_selectedId.Years;
    selectedId.Months = p_selectedId.Months;
    selectedId.Brand = p_selectedId.Brand;
    setSelectedId(selectedId);
    getMonthTableFactorKeysData();
  }

  useEffect(() => {
    getMonthTableFactorKeysData();
  }, [tabFilterObject, selectedId.Brand, selectedId.Years]);

  function getMonthTableFactorKeysData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.sc = screenID;
    object.brandid = selectedId.Brand;
    object.year = selectedId.Years;
    object.month = selectedId.Months;
    object.toggledata = tabFilterObject.toggledata;
    object.toggledatarange = tabFilterObject.Toggledatarange;
    setShowLoadinganimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PFIRSFactorKey/GetMonthTableFactorKeysData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;

          let rank = 0;
          for (var k = 0; k < l_response[1].length; k++) {
            if (l_response[1][k].DealerName === "MENA Average") {
              l_response[1][k].Rank = 0;
            } else {
              rank += 1;
              l_response[1][k].Rank = rank;
            }
          }

          setMonthTableFactorKeysData(l_response);
          setThisGridListData(l_response[1]);
          thisGridListDataRef.current = l_response[1];
          HandleSortAndLoadData();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        setShowLoadinganimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpFileURL, setPopUpFileURL] = useState("");
  const [popUpMessage, setPopUpMessage] = useState(
    "Data has been exported to file successfully.!"
  );
  function DownloadPopupCallBack() {
    setShowPopUp(false);
    setPopUpFileURL("");
  }

  function getSectionScorecardFactorKeysDataForExport() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.sc = screenID;
    object.facilityid = selectedId.Facilities;
    object.dealerid = selectedId.Dealers;
    object.brandid = selectedId.Brand;
    object.year = selectedId.Years;
    object.month = selectedId.Months;
    object.toggledata = tabFilterObject.toggledata;
    object.step = 1;
    object.typeofreportdata = tabFilterObject.typeofreportdata;
    object.toggledatarange = tabFilterObject.Toggledatarange;
    setShowLoadinganimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PFIRSFactorKey/GetSectionScorecardFactorKeysDataForExport",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          let link = l_response[0][0].DownloadData;
          if (l_response[0][0].Status === 1) {
            setPopUpFileURL(link);
            setShowPopUp(true);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        setShowLoadinganimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getSectionScorecardFactorKeysDataForExportPDF() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.sc = screenID;
    object.facilityid = selectedId.Facilities;
    object.dealerid = selectedId.Dealers;
    object.brandid = selectedId.Brand;
    object.year = selectedId.Years;
    object.month = selectedId.Months;
    object.toggledata = tabFilterObject.toggledata;
    object.step = 1;
    object.typeofreportdata = tabFilterObject.typeofreportdata;
    object.toggledatarange = tabFilterObject.Toggledatarange;
    setShowLoadinganimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/PFIRSFactorKey/GetSectionScorecardFactorKeysDataForExportPDF",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          let link = l_response[0][0].DownloadData;
          if (l_response[0][0].Status === 1) {
            setPopUpFileURL(link);
            setShowPopUp(true);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
        setShowLoadinganimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  const [overAllAvgObject, setOverAllAvgObject] = useState<any>({
    CurrentScoreNetwork: 0,
    CurrentScoreSales: 0,
    CurrentScoreAftersales: 0,
    CurrentScoreOverall: 0,
    PriorScoreNetwork: 0,
    PriorScoreSales: 0,
    PriorScoreAftersales: 0,
    PriorScoreOverall: 0,
    MovScoreNetwork: 0,
    MovScoreSales: 0,
    MovScoreAftersales: 0,
    MovScoreOverall: 0,
    PercMovScoreOverall: 0,
  });

  useEffect(() => {
    CalculateAverage();
  }, [MonthTableFactorKeysData]);

  function CalculateAverage() {
    let CurrentScoreNetwork = 0;
    let CurrentScoreSales = 0;
    let CurrentScoreAftersales = 0;
    let CurrentScoreOverall = 0;
    let PriorScoreNetwork = 0;
    let PriorScoreSales = 0;
    let PriorScoreAftersales = 0;
    let PriorScoreOverall = 0;
    let PercMovScoreOverall = 0;

    let CurrentScoreNetworkCount = 0;
    let CurrentScoreSalesCount = 0;
    let CurrentScoreAftersalesCount = 0;
    let CurrentScoreOverallCount = 0;
    let PriorScoreNetworkCount = 0;
    let PriorScoreSalesCount = 0;
    let PriorScoreAftersalesCount = 0;
    let PriorScoreOverallCount = 0;
    let PercMovScoreOverallCount = 0;

    if (MonthTableFactorKeysData[1] && MonthTableFactorKeysData[1].length) {
      for (let i = 0; i < MonthTableFactorKeysData[1].length; i++) {
        if (
          (selectedId.Dealers == 0 ||
            selectedId.Dealers == MonthTableFactorKeysData[1][i].DealerID) &&
          (selectedId.Facilities == 0 ||
            selectedId.Facilities == MonthTableFactorKeysData[1][i].FacilityID)
        ) {
          // if (!ListData[k].IsGreyed) {

          CurrentScoreNetwork +=
            MonthTableFactorKeysData[1][i].CurrentScoreNetwork;
          if (MonthTableFactorKeysData[1][i].CurrentScoreNetwork !== 0) {
            CurrentScoreNetworkCount++;
          }
          CurrentScoreSales += MonthTableFactorKeysData[1][i].CurrentScoreSales;
          if (MonthTableFactorKeysData[1][i].CurrentScoreSales !== 0) {
            CurrentScoreSalesCount++;
          }
          CurrentScoreAftersales +=
            MonthTableFactorKeysData[1][i].CurrentScoreAftersales;
          if (MonthTableFactorKeysData[1][i].CurrentScoreAftersales !== 0) {
            CurrentScoreAftersalesCount++;
          }
          CurrentScoreOverall +=
            MonthTableFactorKeysData[1][i].CurrentScoreOverall;
          if (MonthTableFactorKeysData[1][i].CurrentScoreOverall !== 0) {
            CurrentScoreOverallCount++;
          }

          PriorScoreNetwork += MonthTableFactorKeysData[1][i].PriorScoreNetwork;
          if (MonthTableFactorKeysData[1][i].PriorScoreNetwork !== 0) {
            PriorScoreNetworkCount++;
          }
          PriorScoreSales += MonthTableFactorKeysData[1][i].PriorScoreSales;
          if (MonthTableFactorKeysData[1][i].PriorScoreSales !== 0) {
            PriorScoreSalesCount++;
          }
          PriorScoreAftersales +=
            MonthTableFactorKeysData[1][i].PriorScoreAftersales;
          if (MonthTableFactorKeysData[1][i].PriorScoreAftersales !== 0) {
            PriorScoreAftersalesCount++;
          }
          PriorScoreOverall += MonthTableFactorKeysData[1][i].PriorScoreOverall;
          if (MonthTableFactorKeysData[1][i].PriorScoreOverall !== 0) {
            PriorScoreOverallCount++;
          }

          let l_dMvmt: any = 0;

          if (MonthTableFactorKeysData[1][i].PriorScoreOverall != 0) {
            l_dMvmt =
              ((parseInt(MonthTableFactorKeysData[1][i].CurrentScoreOverall) -
                parseInt(MonthTableFactorKeysData[1][i].PriorScoreOverall)) /
                MonthTableFactorKeysData[1][i].PriorScoreOverall) *
              100;
            l_dMvmt = l_dMvmt.toFixed(1);
          }
          if (l_dMvmt != 0) {
            PercMovScoreOverall += parseFloat(l_dMvmt);
            PercMovScoreOverallCount += 1;
          }
        }
      }

      if (CurrentScoreNetworkCount == 0) CurrentScoreNetworkCount = 1;
      if (CurrentScoreSalesCount == 0) CurrentScoreSalesCount = 1;
      if (CurrentScoreAftersalesCount == 0) CurrentScoreAftersalesCount = 1;
      if (CurrentScoreOverallCount == 0) CurrentScoreOverallCount = 1;

      if (PriorScoreNetworkCount == 0) PriorScoreNetworkCount = 1;
      if (PriorScoreSalesCount == 0) PriorScoreSalesCount = 1;
      if (PriorScoreAftersalesCount == 0) PriorScoreAftersalesCount = 1;
      if (PriorScoreOverallCount == 0) PriorScoreOverallCount = 1;

      let l_intCurrentNetwork: any = (
        CurrentScoreNetwork / CurrentScoreNetworkCount
      ).toFixed(0);
      let l_intCurrentSales: any = (
        CurrentScoreSales / CurrentScoreSalesCount
      ).toFixed(0);
      let l_intCurrentAftersales: any = (
        CurrentScoreAftersales / CurrentScoreAftersalesCount
      ).toFixed(0);
      let l_intCurrentOverall: any = (
        CurrentScoreOverall / CurrentScoreOverallCount
      ).toFixed(0);

      let l_intPriorNetwork: any = (
        PriorScoreNetwork / PriorScoreNetworkCount
      ).toFixed(0);
      let l_intPriorSales: any = (
        PriorScoreSales / PriorScoreSalesCount
      ).toFixed(0);
      let l_intPriorAftersales: any = (
        PriorScoreAftersales / PriorScoreAftersalesCount
      ).toFixed(0);
      let l_intPriorOverall: any = (
        PriorScoreOverall / PriorScoreOverallCount
      ).toFixed(0);

      var l_intVarNetwork = (l_intCurrentNetwork - l_intPriorNetwork).toFixed(
        0
      );
      var l_intVarSales = (l_intCurrentSales - l_intPriorSales).toFixed(0);
      var l_intVarAftersales = (
        l_intCurrentAftersales - l_intPriorAftersales
      ).toFixed(0);
      var l_intVarOverall = (l_intCurrentOverall - l_intPriorOverall).toFixed(
        0
      );

      var l_dMovementAverage: any = 0;
      if (PercMovScoreOverallCount != 0) {
        l_dMovementAverage = PercMovScoreOverall / PercMovScoreOverallCount;
        l_dMovementAverage = l_dMovementAverage.toFixed(1);
      }

      setOverAllAvgObject({
        CurrentScoreNetwork: l_intCurrentNetwork,
        CurrentScoreSales: l_intCurrentSales,
        CurrentScoreAftersales: l_intCurrentAftersales,
        CurrentScoreOverall: l_intCurrentOverall,
        PriorScoreNetwork: l_intPriorNetwork,
        PriorScoreSales: l_intPriorSales,
        PriorScoreAftersales: l_intPriorAftersales,
        PriorScoreOverall: l_intPriorOverall,
        MovScoreNetwork: l_intVarNetwork,
        MovScoreSales: l_intVarSales,
        MovScoreAftersales: l_intVarAftersales,
        MovScoreOverall: l_intVarOverall,
        PercMovScoreOverall: l_dMovementAverage,
      });
    }
  }

  ////  Sorting Starts    /////

  const [filters, setFilters] = useState(["CurrentScoreOverall", "D"]);
  const [thisGridListData, setThisGridListData] = useState([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;

  function SetSortingImage() {
    let imgSortApr: any = document.getElementById("imgSortCurrentScoreNetwork");
    imgSortApr.innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortCurrentScoreSales") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById(
        "imgSortCurrentScoreAftersales"
      ) as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortCurrentScoreOverall") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortPriorScoreNetwork") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortPriorScoreSales") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortPriorScoreAftersales") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortPriorScoreOverall") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortMovScoreNetwork") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortMovScoreSales") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortMovScoreAftersales") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortMovScoreOverall") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    (
      document.getElementById("imgSortPercMovScoreOverall") as HTMLInputElement
    ).innerHTML =
      '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="13px" height="15px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="13px" height="15px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  return (
    <div className="page--contents">
      {showLoadinganimation && <LoadingAnimation />}

      <DownloadPopup
        ShowPopup={showPopUp}
        FileLink={popUpFileURL}
        Message={popUpMessage}
        DownloadPopupCallBack={DownloadPopupCallBack}
      />

      <div className="page--breadcrumb">
        <a>Month League Table</a>
      </div>
      <div className="page--data">
        <div className="flex-container">
          <div className="flex-items">
            <ScorecardFilters
              ScreenID={screenID}
              ScorecardFiltersCallBack={ScorecardFiltersCallBack}
            />

            <TabFilter
              DataType={1}
              SelectedValue={tabFilterObject.Toggledatarange}
              DataList={toggledatarangeArray}
              TabFilterCallback={handleTabFilterCallback}
            />

            <TabFilter
              DataType={2}
              SelectedValue={tabFilterObject.toggledata}
              DataList={toggledataArray}
              TabFilterCallback={handleTabFilterCallback}
            />
          </div>
        </div>
        {MonthTableFactorKeysData && MonthTableFactorKeysData.length > 0 && (
          <>
            <div className="section-table">
              {MonthTableFactorKeysData[0] && (
                <div className="legends-buttons">
                  <div className="single-legend">
                    <p>{MonthTableFactorKeysData[0][0].ScoreTop}</p>
                    <span className="legend-1"></span>
                  </div>
                  <div className="single-legend">
                    <p>{MonthTableFactorKeysData[0][0].ScoreMiddle} </p>
                    <span className="legend-2"></span>
                  </div>
                  <div className="single-legend">
                    <p>{MonthTableFactorKeysData[0][0].ScoreBottom}</p>
                    <span className="legend-3"></span>
                  </div>
                  <div className="single-legend">
                    <p>INACTIVE</p>
                    <span className="legend-4"></span>
                  </div>
                  <a
                    className="btn-primary"
                    title="Export"
                    onClick={() => getSectionScorecardFactorKeysDataForExport()}
                  >
                    <img
                      src="images/export.png"
                      width="13px"
                      height="15px"
                      alt="export"
                    />
                  </a>
                  <a
                    className="btn-primary"
                    title="Download PDF"
                    onClick={() =>
                      getSectionScorecardFactorKeysDataForExportPDF()
                    }
                  >
                    <img
                      src="images/download.svg"
                      width="13px"
                      height="15px"
                      alt="download"
                    />
                  </a>
                </div>
              )}

              <div className="flex-details table-norms table-level-3">
                {MonthTableFactorKeysData[1] && (
                  <ColumnFilterCheckboxList
                    DataType={1}
                    RefreshFilters={refreshFilters}
                    GridData={MonthTableFactorKeysData[1]}
                    ColumnName={selectedColumnName}
                    ColumnFilterCheckboxListCallback={
                      filterCheckboxListCallback
                    }
                    GetFilteredLists={getFilteredLists}
                    ReturnAllFilterdLists={{}}
                    ClickPosition={clickPosition}
                    Orientation={"Center"}
                    ColumnOrientation={[
                      { Name: "DealerName", Orientation: "Right" },
                    ]}
                  />
                )}
                <div className="table-scroll">
                  <table className="part-head trend-table" id="tblData">
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th className="b-black"></th>
                        <th colSpan={4} className="b-black">
                          Current Month Score
                        </th>
                        <th colSpan={4} className="b-black">
                          Prior Month Score
                        </th>
                        <th colSpan={5} className="b-black">
                          Movement in Score
                        </th>
                      </tr>
                      <tr>
                        <th>Rank</th>

                        <th>
                          <span
                            onClick={(e) =>
                              ShowColumnFilterList(e, "DealerName")
                            }
                            data-function="ShowColumnFilterList"
                          >
                            Importer Name
                          </span>
                        </th>
                        <th>
                          <span
                            onClick={(e) => ShowColumnFilterList(e, "Market")}
                            data-function="ShowColumnFilterList"
                          >
                            Market
                          </span>
                        </th>
                        <th>
                          <span
                            onClick={(e) => ShowColumnFilterList(e, "Facility")}
                            data-function="ShowColumnFilterList"
                          >
                            Retailer
                          </span>
                        </th>
                        <th className="b-black">
                          <span
                            onClick={(e) =>
                              ShowColumnFilterList(e, "FacilityType")
                            }
                            data-function="ShowColumnFilterList"
                          >
                            RT
                          </span>
                        </th>
                        <th>
                          <span className="sort-spn">Network</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("CurrentScoreNetwork")
                            }
                            title="Sort By Network"
                          >
                            <span id="imgSortCurrentScoreNetwork"></span>
                          </a>
                        </th>
                        <th>
                          <span className="sort-spn">Sales</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("CurrentScoreSales")
                            }
                            title="Sort By Sales"
                          >
                            <span id="imgSortCurrentScoreSales"></span>
                          </a>
                        </th>
                        <th>
                          <span className="sort-spn">Aftersales</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("CurrentScoreAftersales")
                            }
                            title="Sort By Aftersales"
                          >
                            <span id="imgSortCurrentScoreAftersales"></span>
                          </a>
                        </th>
                        <th className="b-black">
                          <span className="sort-spn">Overall</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("CurrentScoreOverall")
                            }
                            title="Sort By Overall"
                          >
                            <span id="imgSortCurrentScoreOverall"></span>
                          </a>
                        </th>

                        <th>
                          <span className="sort-spn">Network</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("PriorScoreNetwork")
                            }
                            title="Sort By Network"
                          >
                            <span id="imgSortPriorScoreNetwork"></span>
                          </a>
                        </th>
                        <th>
                          <span className="sort-spn">Sales</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("PriorScoreSales")
                            }
                            title="Sort By Sales"
                          >
                            <span id="imgSortPriorScoreSales"></span>
                          </a>
                        </th>
                        <th>
                          <span className="sort-spn">Aftersales</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("PriorScoreAftersales")
                            }
                            title="Sort By Aftersales"
                          >
                            <span id="imgSortPriorScoreAftersales"></span>
                          </a>
                        </th>
                        <th className="b-black">
                          <span className="sort-spn">Overall</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("PriorScoreOverall")
                            }
                            title="Sort By Overall"
                          >
                            <span id="imgSortPriorScoreOverall"></span>
                          </a>
                        </th>

                        <th>
                          <span className="sort-spn">Network</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("MovScoreNetwork")
                            }
                            title="Sort By Network"
                          >
                            <span id="imgSortMovScoreNetwork"></span>
                          </a>
                        </th>
                        <th>
                          <span className="sort-spn">Sales</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("MovScoreSales")
                            }
                            title="Sort By Sales"
                          >
                            <span id="imgSortMovScoreSales"></span>
                          </a>
                        </th>
                        <th>
                          <span className="sort-spn">Aftersales</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("MovScoreAftersales")
                            }
                            title="Sort By Aftersales"
                          >
                            <span id="imgSortMovScoreAftersales"></span>
                          </a>
                        </th>
                        <th>
                          <span className="sort-spn">Overall</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("MovScoreOverall")
                            }
                            title="Sort By Overall"
                          >
                            <span id="imgSortMovScoreOverall"></span>
                          </a>
                        </th>
                        <th className="b-black">
                          <span className="sort-spn">% Mvmt</span>
                          <a
                            onClick={() =>
                              LoadWithSelectedSort("PercMovScoreOverall")
                            }
                            title="Sort By Overall"
                          >
                            <span id="imgSortPercMovScoreOverall"></span>
                          </a>
                        </th>
                      </tr>

                      <tr>
                        <th colSpan={5} className="text-left b-black">
                          <b>Network Average</b>
                        </th>
                        <th className="text-right">
                          <b>{overAllAvgObject.CurrentScoreNetwork}</b>
                        </th>
                        <th className="text-right">
                          <b>{overAllAvgObject.CurrentScoreSales}</b>
                        </th>
                        <th className="text-right">
                          <b>{overAllAvgObject.CurrentScoreAftersales}</b>
                        </th>
                        <th className="text-right b-black">
                          <b>{overAllAvgObject.CurrentScoreOverall}</b>
                        </th>
                        <th className="text-right">
                          <b>{overAllAvgObject.PriorScoreNetwork}</b>
                        </th>
                        <th className="text-right">
                          <b>{overAllAvgObject.PriorScoreSales}</b>
                        </th>
                        <th className="text-right">
                          <b>{overAllAvgObject.PriorScoreAftersales}</b>
                        </th>
                        <th className="text-right b-black">
                          <b>{overAllAvgObject.PriorScoreOverall}</b>
                        </th>
                        <th className="text-right">
                          <b>
                            {overAllAvgObject.MovScoreNetwork > 0
                              ? "+" + overAllAvgObject.MovScoreNetwork
                              : overAllAvgObject.MovScoreNetwork}
                          </b>
                        </th>
                        <th className="text-right">
                          <b>
                            {overAllAvgObject.MovScoreSales > 0
                              ? "+" + overAllAvgObject.MovScoreSales
                              : overAllAvgObject.MovScoreSales}
                          </b>
                        </th>
                        <th className="text-right">
                          <b>
                            {overAllAvgObject.MovScoreAftersales > 0
                              ? "+" + overAllAvgObject.MovScoreAftersales
                              : overAllAvgObject.MovScoreAftersales}
                          </b>
                        </th>
                        <th className="text-right">
                          <b>
                            {overAllAvgObject.MovScoreOverall > 0
                              ? "+" + overAllAvgObject.MovScoreOverall
                              : overAllAvgObject.MovScoreOverall}
                          </b>
                        </th>
                        <th className="text-right b-black">
                          <b>
                            {overAllAvgObject.PercMovScoreOverall > 0
                              ? "+" + overAllAvgObject.PercMovScoreOverall
                              : overAllAvgObject.PercMovScoreOverall}
                          </b>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {thisGridListData &&
                        thisGridListData.map((item: any, index: any) => (
                          <React.Fragment key={"Main" + index}>
                            {!item.IsExcluded &&
                              (selectedId.Dealers == 0 ||
                                selectedId.Dealers == item.DealerID) &&
                              (selectedId.Facilities == 0 ||
                                selectedId.Facilities == item.FacilityID) && (
                                <tr>
                                  <td
                                    className={"ScoreCategory" + item.ScoreType}
                                  >
                                    {item.Rank}
                                  </td>
                                  <td
                                    className={"ScoreCategory" + item.ScoreType}
                                  >
                                    {item.DealerName}
                                  </td>
                                  <td
                                    className={"ScoreCategory" + item.ScoreType}
                                  >
                                    {item.Market}
                                  </td>
                                  <td
                                    className={"ScoreCategory" + item.ScoreType}
                                  >
                                    {item.Facility}
                                  </td>
                                  <td
                                    className={
                                      "b-black ScoreCategory" + item.ScoreType
                                    }
                                  >
                                    {item.FacilityType}
                                  </td>

                                  <td
                                    className={
                                      "text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    {item.CurrentScoreNetwork}
                                  </td>
                                  <td
                                    className={
                                      "text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    {item.CurrentScoreSales}
                                  </td>
                                  <td
                                    className={
                                      "text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    {item.CurrentScoreAftersales}
                                  </td>
                                  <td
                                    className={
                                      "b-black text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    <b>{item.CurrentScoreOverall}</b>
                                  </td>
                                  <td
                                    className={
                                      "text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    {item.PriorScoreNetwork}
                                  </td>
                                  <td
                                    className={
                                      "text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    {item.PriorScoreSales}
                                  </td>
                                  <td
                                    className={
                                      "text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    {item.PriorScoreAftersales}
                                  </td>
                                  <td
                                    className={
                                      "b-black text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    <b>{item.PriorScoreOverall}</b>
                                  </td>

                                  <td
                                    className={
                                      "text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    {item.MovScoreNetwork > 0
                                      ? "+" + item.MovScoreNetwork
                                      : item.MovScoreNetwork}
                                  </td>
                                  <td
                                    className={
                                      "text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    {item.MovScoreSales > 0
                                      ? "+" + item.MovScoreSales
                                      : item.MovScoreSales}
                                  </td>
                                  <td
                                    className={
                                      "text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    {item.MovScoreAftersales > 0
                                      ? "+" + item.MovScoreAftersales
                                      : item.MovScoreAftersales}
                                  </td>
                                  <td
                                    className={
                                      "text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    <b>
                                      {item.MovScoreOverall > 0
                                        ? "+" + item.MovScoreOverall
                                        : item.MovScoreOverall}
                                    </b>
                                  </td>
                                  <td
                                    className={
                                      "b-black text-right ScoreCategory" +
                                      item.ScoreType
                                    }
                                  >
                                    <b>
                                      {item.PercMovScoreOverall > 0
                                        ? "+" + item.PercMovScoreOverall + "%"
                                        : item.PercMovScoreOverall + "%"}
                                    </b>
                                  </td>
                                </tr>
                              )}
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default MonthLeagueTable;
